const Vars = {
  nit: '986c0f6f-c2df-4a1c-9443-5fab13cafe10',
  operationType: 'e44ac6b6-c10a-4663-9a99-dd463a65f6e7',
  unitProducts: '01fa03f8-6735-409f-ba9a-62ed1bcd192b',
  paymentMethotd: 'ac20b0ad-1533-4ca3-ac7c-4bbbab443649',
  mandates: '7f15b0ce-97f1-412a-8f66-b30ff526333f',
};

export default Vars;
